import _ from "@lodash";
import { Typography, withStyles } from "@material-ui/core";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import Pagamento from "app/Core/Funcionalidade/Pagamento/Pagamento";
import React from "react";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import XAPPButton from "../Button/XAPPButton";
import clsx from "clsx";

const styles = () => ({
    button: {
        borderColor: "#666 !important",
        color: "#666 !important",

    }
});


class BannerTop extends XAPPComponent {

    state = {
        tipo: null,
        obj: null,
    };

    componentDidUpdate(prevProps) {
        const { empresa = null, statusXapp = null } = this.props;
        const { tipo } = this.state;

        if (_.isNull(tipo) && !_.isNull(empresa) && !_.isNull(statusXapp)) {
            let AArray = _.intersectionBy(Object.keys(statusXapp), ["ASSINATURA_PENDENTE", "TERMINO_CONTRATO"]);
            if (AArray && AArray.length > 0) {
                const key = AArray[0];
                if (Number(statusXapp[key].expiracao) >= 0) {
                    this.setTipoMensagem(key, statusXapp[key].expiracao);
                }
            }
        }

        if (!_.isNull(statusXapp) && !_.isNull(tipo) && Object.keys(statusXapp).length < 1) {
            this.setTipoMensagem(null, null);
        }
    }
    setTipoMensagem = (_ATipo = null, _AObj = null) => {
        this.setState(_.set({ ...this.state, tipo: _ATipo, obj: _AObj }));
    };

    getMensagem = () => {
        const { tipo, obj } = this.state;
        switch (tipo) {
            case "ASSINATURA_PENDENTE": {
                let prazo = "";
                switch (Number(obj)) {
                    case 0: prazo = "hoje!"; break;
                    case 1: prazo = "amanhã!"; break;
                    default: prazo = `em ${Number(obj)} dias!`; break;
                }
                return `Seu período de avaliação termina ${prazo}`;
            }
            case "TERMINO_CONTRATO": {
                let prazo = "";
                switch (Number(obj)) {
                    case 0: prazo = "hoje"; break;
                    case 1: prazo = "amanhã"; break;
                    default: prazo = `em ${Number(obj)} dias`; break;
                }
                return `Seu contrato termina ${prazo}, entre em contato com o administrador do sistema...`;
            }
            default: return null;
        }
    };

    getAcao = () => {
        const { classes } = this.props;
        const { tipo } = this.state;
        switch (tipo) {
            case "ASSINATURA_PENDENTE": return (
                <Pagamento
                    chave={tipo}
                >
                    <XAPPButton
                        tooltip={{ "title": "Assinar", "placement": "top" }}
                        type="Button"
                        className={clsx(classes.button, "py-6 my-4")}
                        onClick={() => { }}
                        icon={"shopping"}
                        color="primary"
                        label="assinar"
                        variant="outlined"
                        iconProps="mr-8"
                        key={"assinarPlano"}
                    />
                </Pagamento>
            );
            default: return (
                <div />
            );
        }
    };

    render() {
        const { tipo } = this.state;
        const { empresa, statusXapp } = this.props;

        return (
            <React.Fragment>
                {!_.isNull(statusXapp) && !_.isNull(tipo) && !_.isNull(empresa) && !document.location.href.includes("/pub-") &&
                    <div className={"flex items-center justify-center gap-8 flex-wrap min-h-48"} style={{ "backgroundColor": "#FECA04" }}>
                        <Typography className={"text-16 text-center"} style={{ color: "#666", padding: "5px" }}>{this.getMensagem()}</Typography>
                        {this.getAcao()}
                    </div>
                }
            </React.Fragment>
        );
    }
}

function mapStateToProps({ auth, fuse }) {
    return {
        user: auth.user.data,
        statusXapp: auth.user.statusXapp,
        empresa: fuse.navigation.empresa,
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps)(BannerTop)));